import React from 'react';
import { Dropdown } from 'react-bootstrap';
import DiscoveryTooltip from 'DiscoveryTooltip';

// Style-guide page header: one block, four slots, fixed order —
// eyebrow / domain icon + title / meta row / actions.
// `header` renders as a 24px sentence-case title (no more ALL-CAPS h2).
// Optional slots: `eyebrow` (screen/type name, caps), `meta` (id · kind ·
// status pill row), `primaryAction` (the one filled-blue button for the
// screen). The Actions dropdown hides entirely when it has no items —
// never ship a dead control.
function PageHeader({ icon: Icon, header, actions, tooltip, eyebrow, meta, primaryAction, iconVariant }) {
  const hasActions = actions && actions.length > 0;
  return (
    <div
      role="heading"
      aria-level="1"
      className='sg-page-header mb-3 mt-3'
    >
      <div className='sg-page-header__titles'>
        { eyebrow && <div className='sg-eyebrow'>{ eyebrow }</div> }
        <div className='sg-page-header__title-row'>
          { Icon && (
            <DiscoveryTooltip placement='bottom' text={tooltip}>
              <span className={`sg-domain-icon${iconVariant ? ` sg-domain-icon--${iconVariant}` : ''}`}>
                <Icon size='30px' />
              </span>
            </DiscoveryTooltip>
          )}
          <h2 className='sg-title'>{ header }</h2>
        </div>
        { meta && <div className='sg-page-header__meta'>{ meta }</div> }
      </div>
      <div className='sg-page-header__actions'>
        { primaryAction }
        { hasActions && (
          <Dropdown alignRight={true}>
            <Dropdown.Toggle
              data-testid='page-header-actions-toggle'
              size='sm'
              className="pr-4 pl-4"
              variant='outline-secondary'
            >
              Actions
            </Dropdown.Toggle>
            <Dropdown.Menu>
              { actions.map(a => a) }
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
    </div>
  );
}

export default PageHeader;
